import { render, staticRenderFns } from "./ServiceCreationSlider.vue?vue&type=template&id=0d8d7c6c&scoped=true&"
import script from "./ServiceCreationSlider.vue?vue&type=script&lang=ts&"
export * from "./ServiceCreationSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8d7c6c",
  null
  
)

export default component.exports